import { _ as __rest } from './tslib.es6-613ce1cd.js';
import { h } from './index-5faac9d7.js';
import { p as passBreadcrumbsParams } from './utils-1b416b6b.js';

const isRoutingDisabled = (props) => {
  return 'url' in props && !!props.url;
};

const RouterLinkView = (props, children) => {
  const { name, url, pageId, pageName, linkClassName, target, storageName, breadcrumbs, } = props;
  const storeBreadcrumbsParams = {
    id: pageId,
    name,
    url,
    storageName,
    breadcrumbs,
    pageName,
  };
  if (isRoutingDisabled(props)) {
    return (h("a", { class: linkClassName, href: url, target: target !== null && target !== void 0 ? target : '_self', onClick: passBreadcrumbsParams(storeBreadcrumbsParams) }, children));
  }
  const _a = props, { routerClassName } = _a, routerProps = __rest(_a, ["routerClassName"]);
  return (h("pes-router-link", Object.assign({ key: pageId, class: routerClassName }, routerProps, { saveInIndexDB: passBreadcrumbsParams(storeBreadcrumbsParams) }),
    h("a", { class: linkClassName, href: "#" }, children)));
};

export { RouterLinkView as R, isRoutingDisabled as i };
